import { useStepsQuery } from './useStepsQuery';
import { useStepsSearch } from './useStepsSearch';
import { useStepsTableColumns } from './useStepsTableColumns';

export const useSteps = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useStepsQuery(filters);
    const { keyword } = useStepsSearch();
    const { columns } = useStepsTableColumns();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.displayName?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
